import React from 'react';
import UserProfileEditor from './UserProfile.editor';
import UserProfileProperties from './UserProfile.properties';
import { registerComponent, registerSkinnableComponent } from '../registry';
import { UserProfileSkinnable } from './UserProfileSkinnable';
import ComponentSkinWrapper from '../../skins/ComponentSkinWrapper';

// constants 파일에서 컴포넌트 타입 상수 가져오기
// 해당 상수가 없을 경우 상수 추가 필요
import { COMPONENT_TYPES } from '../../../constants';

// 스킨 가능한 컴포넌트로 등록
registerSkinnableComponent(UserProfileSkinnable);

// 외부 스킨 지원을 위한 래퍼 컴포넌트
const UserProfileWrapper: React.FC<any> = (props) => {
  const selectedSkin = props.skin || props.componentProps?.skin || 'basic';
  
  return (
    <ComponentSkinWrapper 
      component={UserProfileSkinnable}
      componentData={props}
      skinId={selectedSkin}
      mode={props.isPreview ? 'editor' : 'preview'}
      editorProps={props}
    />
  );
};

// 레거시 호환성을 위한 기존 컴포넌트 등록
registerComponent({
  type: COMPONENT_TYPES.USER_PROFILE || 'USER_PROFILE', // 상수가 없을 경우 문자열 직접 사용
  component: UserProfileWrapper,
  editorComponent: UserProfileEditor,
  properties: UserProfileProperties,
  defaultProps: {
    // 기본 속성 정의
    style: {
      padding: '20px',
      backgroundColor: '#fff',
      borderRadius: '8px',
      boxShadow: '0 2px 10px rgba(0, 0, 0, 0.1)',
      fontFamily: 'Noto Sans KR, sans-serif',
      maxWidth: '800px',
      margin: '20px auto',
    },
    componentProps: {
      skin: 'basic',
      title: '내 정보',
      showPassword: true,
      showPhone: true,
      showEmail: true,
      showBirthday: true,
      showAddress: true
    },
    varFields: {
      var01: { show: false, label: "" },
      var02: { show: false, label: "" },
      var03: { show: false, label: "" }
    },
    basicFields: {
      userId: true,
      name: true,
      password: true,
      phone: true,
      email: true,
      birthday: true,
      createdAt: true,
      address: true,
      referralLink: true
    }
  },
  category: 'member', // 컴포넌트 카테고리
  icon: '👤', // 대표 아이콘
  name: '회원 정보', // 표시할 이름
  skinnable: UserProfileSkinnable // 스킨 가능 컴포넌트 연결
});

// 컴포넌트 및 타입 내보내기
export { UserProfileWrapper as UserProfileComponent };
export { default as UserProfileEditor } from './UserProfile.editor';
export { default as UserProfileProperties } from './UserProfile.properties';
export * from './UserProfile.types'; 